import { datadogRum } from '@datadog/browser-rum';

import { appEnv, appVersion, dataDogRumApplicationId, dataDogRumClientToken } from './config';

const ddRumClient = datadogRum;

export const addErrorToTracker = (error: string | object | any, data?: object | string | any): void => {
	if (appEnv !== 'production') {
		// eslint-disable-next-line no-console
		console.log({ message: 'ERROR FOUND', error, data });
	}
	ddRumClient.addError(error, data);
};

export const addGlobalContext = (key: string, value: string): void => {
	ddRumClient.addRumGlobalContext(key, value);
};

export const setGlobalContext = (key: string, value: string): void => {
	ddRumClient.setRumGlobalContext({ [key]: value });
};

export const addRumAction = (key: string, data: object): void => {
	ddRumClient.addAction(key, data);
};

export default ddRumClient;
